import { EAdvancedFilterType } from 'shared/enums/EAdvancedFilterType';

export const GEO_FILTERS = [EAdvancedFilterType.geo, EAdvancedFilterType.coworking, EAdvancedFilterType.bsCenter];
